<template>
    <div>
        <p>- Unknown Message Type - ID: {{ message.id }}</p>
        <p v-if="!tried">
            <a href="#" @click="discover">try to discover</a>
        </p>
        <p v-else class="text-red-400">
            Sorry, try again later :/
        </p>
    </div>
</template>

<script>
    import {Zapin} from "@/services/Api";

    export default {
        props: {
            message: Object,
            instanceId: String
        },

        data() {
            return {
                tried: false
            }
        },

        methods: {
            async discover() {
                const result = await Zapin.chats().discover(this.instanceId, this.message.id);

                this.tried = true;

                if(result.data && result.data.content_type !== 'UNKNOWN') {
                    this.$emit('redraw', result.data);
                }
            }
        }
    }
</script>
